import { registerPlugin } from '@capacitor/core';

type RecorderKitPlugin = {
  startRecording(options: { fileName: string }): Promise<{ filePath: string }>;
  pauseRecording(): Promise<void>;
  resumeRecording(): Promise<void>;
  stopRecording(): Promise<void>;
  isRecording(): Promise<{ isRecording: boolean }>;
  acquireScreenWakeLock(): Promise<{ acquired: boolean }>;
  releaseScreenWakeLock(): Promise<{ released: boolean }>;
};

export const RecorderKit = registerPlugin<RecorderKitPlugin>('RecorderKit');
